import { useCallback, useEffect, useState } from "react";
import Api from "../../../../shared/api/api";
import "../styles/AdminMarketplaces.css";

export default function MarketplacesPage() {
  const [marketplaces, setMarketplaces] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [updatingCode, setUpdatingCode] = useState("");
  const [error, setError] = useState("");

  const fetchMarketplaces = useCallback(async () => {
    setIsLoading(true);
    setError("");

    try {
      const response = await Api.request("api/marketplaces");

      setMarketplaces(
        Array.isArray(response?.marketplaces)
          ? response.marketplaces
          : []
      );
    } catch (requestError) {
      console.error(
        "Unable to load marketplaces:",
        requestError
      );

      setError(
        "The marketplace settings could not be loaded."
      );
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchMarketplaces();
  }, [fetchMarketplaces]);

  const toggleMarketplace = async (code) => {
    setUpdatingCode(code);
    setError("");

    try {
      await Api.request(
        `api/marketplaces/toggle/${encodeURIComponent(code)}`,
        {},
        "patch"
      );

      await fetchMarketplaces();
    } catch (requestError) {
      console.error(
        `Unable to toggle marketplace ${code}:`,
        requestError
      );

      setError(
        requestError?.message ||
          "The marketplace could not be updated."
      );
    } finally {
      setUpdatingCode("");
    }
  };

  return (
    <section className="adminPageContainer">
      <h1 className="adminPageHeader">
        Marketplace Control
      </h1>

      {error && (
        <p className="adminStatusMessage error" role="alert">
          {error}
        </p>
      )}

      {isLoading ? (
        <p className="loadingText" role="status">
          Loading marketplaces...
        </p>
      ) : marketplaces.length === 0 ? (
        <p className="loadingText">
          No marketplaces were found.
        </p>
      ) : (
        <div className="tableWrapper">
          <table className="adminTable">
            <thead>
              <tr>
                <th scope="col">Marketplace</th>
                <th scope="col">Domain</th>
                <th scope="col">Status</th>
                <th scope="col">Action</th>
              </tr>
            </thead>

            <tbody>
              {marketplaces.map((marketplace) => {
                const isUpdating =
                  updatingCode === marketplace.code;

                return (
                  <tr key={marketplace.code}>
                    <td data-label="Marketplace">
                      {marketplace.name}
                    </td>

                    <td data-label="Domain">
                      {marketplace.domain}
                    </td>

                    <td data-label="Status">
                      <span
                        className={`statusDot ${
                          marketplace.active
                            ? "active"
                            : "inactive"
                        }`}
                        aria-hidden="true"
                      />

                      {marketplace.active
                        ? "Active"
                        : "Inactive"}
                    </td>

                    <td data-label="Action">
                      <button
                        type="button"
                        className="toggleButton"
                        onClick={() =>
                          toggleMarketplace(
                            marketplace.code
                          )
                        }
                        disabled={isUpdating}
                      >
                        {isUpdating
                          ? "Updating..."
                          : marketplace.active
                            ? "Disable"
                            : "Enable"}
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}